module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "print-no-show",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar tarjeta de embarque'
      }),
      expression: "{ html: 'Descargar tarjeta de embarque' }",
      arg: "left"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadCardTravel
    }
  }, [_c('v-icon', [_vm._v("card_travel")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Imprimir detalle de reserva'
      }),
      expression: "{ html: 'Imprimir detalle de reserva' }",
      arg: "left"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "text-xs-left": "",
      "pr-4": ""
    }
  }, [_c('v-layout', {
    staticClass: "card-detail",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.hotelName) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "px-3": ""
    }
  }, [_c('h3', {
    staticClass: "card-detail-name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.name) + "\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.lastName) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "default-height",
    attrs: {
      "xs12": "",
      "pl-3": "",
      "pr-4": "",
      "py-0": ""
    }
  }, [(_vm.booking.summary.personalInformation.specialRequest) ? _c('span', {
    staticClass: "card-detail-comment"
  }, [_vm._v("\n\t\t\t\t\t\t\"" + _vm._s(_vm.booking.summary.personalInformation.specialRequest) + "\"\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-divider', {
    staticClass: "card-detail-hr"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-footer",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Email:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.email))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Teléfono:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v("+" + _vm._s(_vm.booking.summary.personalInformation.phone))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    staticClass: "card-detail",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-5": "",
      "pt-3": "",
      "pb-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNúmero de Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.numReservation))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tReserve Number GDS:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.code))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEstado de la Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bookingStateName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSitio web:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v("Sitio Web")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFecha de Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingDate, 'DD/MM/YYYY HH:mm:ss')) + " (Extranet TimeZone)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tÚltima actualización:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.updatedAt, 'DD/MM/YYYY HH:mm:ss')) + " (Hotel TimeZone)")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-total",
    attrs: {
      "xs12": "",
      "px-5": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "py-2": ""
    }
  }, [_c('label', [_vm._v("Venta Mensual")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "py-2": "",
      "text-xs-right": ""
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.total)) + " " + _vm._s(_vm.booking.summary.promotion.iso_currency))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('table', {
    staticClass: "card-detail-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return _c('th', {
      key: column.id
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(column.name) + "\n\t\t\t\t\t\t")])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.roomName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.guests))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.booking.adults))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.booking.childrens))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.summary.booking.checkIn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.summary.booking.checkOut)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.stateName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.total)) + " " + _vm._s(_vm.booking.summary.promotion.iso_currency))])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-info",
    attrs: {
      "xs12": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Observaciones:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "pr-2": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.observations))])])], 1), _vm._v(" "), (_vm.booking.summary.services) ? _c('v-layout', {
    staticClass: "card-detail-rates",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Servicios adicionales:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "mb-3": ""
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th', [_vm._v("Precio")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.booking.summary.services), function(service) {
    return _c('tr', {
      key: service.id
    }, [_c('td', [_vm._v(_vm._s(service.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(service.total)) + " " + _vm._s(service.iso_currency))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.earlyCheckIn.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.earlyCheckIn.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.summary.earlyCheckIn.total)) + " " + _vm._s(_vm.booking.summary.earlyCheckIn.iso_currency))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.lateCheckOut.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.lateCheckOut.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.summary.lateCheckOut.total)) + " " + _vm._s(_vm.booking.summary.lateCheckOut.iso_currency))])])], 2)])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "card-detail-rates",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Tarifas:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": ""
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Habitación:")]), _vm._v(" "), _c('th', [_vm._v("Tarifa")]), _vm._v(" "), _c('th', [_vm._v("Día")]), _vm._v(" "), _c('th', [_vm._v("Precio")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.booking.summary.ratesPerDates), function(rate) {
    return _c('tr', {
      key: rate.id
    }, [_c('td', [_vm._v(_vm._s(_vm.booking.summary.promotion.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(rate.date_reservation)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(rate.price)) + " " + _vm._s(rate.iso_currency))]), _vm._v(" "), _c('td')])
  }))])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('table', {
    staticClass: "card-detail-table card-footer-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Datos de la tarjeta")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Nombre del titular de la tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.name) + "\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.lastName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Número de la tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.cardNumber))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tipo de tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.cardType))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fecha de expiración:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.month) + " / " + _vm._s(_vm.booking.summary.personalInformation.payment.year))])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3249e3f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/guest/detail-guest.vue
// module id = 1614
// module chunks = 71